import Swiper from 'swiper/bundle';

var sliderSenarProgramsAndServicesContent = document.querySelector(".slide-senarProgramsAndServices-container")

if (sliderSenarProgramsAndServicesContent) {
	new Swiper(sliderSenarProgramsAndServicesContent, {
		slidesPerView: "auto",
		spaceBetween: 32,
		centeredSlides: true,
		grabCursor: 'true',


		navigation: {
			nextEl: sliderSenarProgramsAndServicesContent.querySelector(".swiper-button-next"),
			prevEl: sliderSenarProgramsAndServicesContent.querySelector(".swiper-button-prev"),
		},
	});
}
